import React from 'react';
import { Menu, Layout } from 'antd';
import { 
  HomeOutlined, 
  ShoppingCartOutlined, 
  SettingOutlined,
  PlusOutlined,
  EditOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const { Header } = Layout;

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: 'Home',
    },
    {
      key: '/cart',
      icon: <ShoppingCartOutlined />,
      label: 'Cart',
    },
    {
      key: '/product-management',
      icon: <ShoppingCartOutlined />,
      label: 'Products',
    },
    // Hidden admin access (you can remove this or make it conditional)
    {
      key: '/admin-login',
      icon: <SettingOutlined />,
      label: 'Admin',
      style: { display: 'none' }, // This hides it from the menu
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  return (
    <Header style={{ 
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '0 24px',
      position: 'sticky',
      top: 0,
      zIndex: 1000,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        height: '100%',
        color: 'white',
        fontSize: '18px',
        fontWeight: 'bold',
        marginRight: '24px'
      }}>
        E-Commerce Admin
      </div>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={handleMenuClick}
        style={{
          background: 'transparent',
          border: 'none',
          flex: 1,
          lineHeight: '64px'
        }}
      />
    </Header>
  );
};

export default Navigation; 